export default {
  rigidBodyTypeTitle: '刚体类型',
  rigidBodyType: {
    notRigidBody: '非刚体',
    notRigidBodyTip: '不具有物理性质，仅作为图片展示。',
    staticRigidBody: '静态刚体',
    staticRigidBodyTip: '保持静止的物体，会与其他刚体发生碰撞。',
    kinematicRigidBody: '运动学刚体',
    kinematicRigidBodyTip:
      '不考虑受力情况和物体质量，以设定的速度、加速度运动的物体，会与其他刚体发生碰撞。',
    dynamicRigidBody: '动力学刚体',
    dynamicRigidBodyTip:
      '有一定质量并在外力作用下运动、遵循牛顿运动定律的物体，会与其他刚体发生碰撞。',
  },
  edge: {
    title: '刚体轮廓精度',
    titleTip:
      '数值越大，精细程度越高，同时性能消耗也越大，建议选择尽可能小的刚好合适的档位即可',
    previewBtnText: '预览当前刚体轮廓',
    closePreviewBtnText: '关闭预览',
    previewAllBtnText: '预览全部刚体轮廓',
    previewAllBtnTip:
      '预览全部刚体轮廓，确保初始状态下，刚体之间无重叠。刚体重叠会受物理影响产生相互作用力，导致试玩时出错。',
  },
}
